import { useState, useRef } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Breadcrumb } from "react-bootstrap";
import '../App.css';
import HelpButton from "./HelpButton";

/*대표실 ceo-office*/
function Page2() {
  
  const [showTablePopover, setShowTablePopover] = useState(false);
  const [TablePopoverText, setTablePopoverText] = useState('');
  const TableRef = useRef(null);

  const handleTableClick = () => {
  setTablePopoverText("먼지가 약간 쌓여있다");
  setShowTablePopover(true);
  setTimeout(() => setShowTablePopover(false), 2000);
};

const [showBinPopover, setShowBinPopover] = useState(false);
  const [BinPopoverText, setBinPopoverText] = useState('');
  const BinRef = useRef(null);

  const handleBinClick = () => {
  setBinPopoverText("텅 비어있... 어? 쪽지가 있다");
  setShowBinPopover(true);
  setTimeout(() => setShowBinPopover(false), 2000);
};
  
  return (
    <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            alert('아직 일을 마치지 못했다');
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/office' }}>
          사무실
        </Breadcrumb.Item>
        <Breadcrumb.Item active>대표실</Breadcrumb.Item>
      </Breadcrumb>
      
      {/* 오른쪽 상단 버튼 */}
        <HelpButton />
      </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start pb-5">
        <p>국내에서 손꼽히는 실력자의 사무실</p>
        <p>간소하다</p>
      </div>

      <div
      className="d-flex justify-content-center align-content-center flex-wrap" 
        style={{height: 'calc(100vh - 400px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'flex-end',
        gap: '10px',
        marginTop: '-10vh',
         }}>
        <button
          ref={TableRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleTableClick}
          style={{
            width: '30vw',
            height: '20vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >탁자</button>

          <div style ={{position: 'relative', width: '7vw', height: '10vh'}}>
          <button
          ref={BinRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleBinClick}
          style={{
            width: '100%',
            height: '100%',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '80%',
          }}
          >휴지통</button>

          {/* 작은 5px 버튼, 대각선 아래쪽 (오른쪽 아래) */}
    <p class="d-inline-flex gap-1">
      <a class="btn btn-primary" type ="button" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample" 
      style={{
            position: 'absolute',
            width: '5px',
            height: '5px',
            backgroundColor: 'black',
            border: 'none',
            bottom: '0',
            right: '0',
            padding: 0,
          }}>
        .
      </a>
    </p>

      <div class="collapse" id="collapseExample" style={{ width:'25vw', maxHeight: '30vh', overflowY:'auto'}}>
      <div class="card card-body">
          <p class="fst-italic text-decoration-line-through">사무실 청소</p>
          <p class="fst-italic text-decoration-line-through">세금 납부</p>
          <p class="fst-italic">집 우편함에 잘못 들어온 편지 문의</p>
      </div>
      </div>
     </div>
    </div> 

          {TableRef.current && (
            <Overlay target={TableRef.current} show={showTablePopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{TablePopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}

          {BinRef.current && (
            <Overlay target={BinRef.current} show={showBinPopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{BinPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>
          )}


    </div>      
    );
}

export default Page2;
